import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSquareShapeIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 2H7a5 5 0 0 0-5 5v10a4.9997 4.9997 0 0 0 5 5h10a4.9997 4.9997 0 0 0 5-5V7a5 5 0 0 0-5-5Zm3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10Z"/>
  </SvgIcon>
}

export default LineSquareShapeIcon
